import React from 'react';
import { useTransition, UseTransitionProps } from 'react-spring';
import styled, { css } from 'styled-components';
import type { IconType } from '~/components/atom/Icon';
import ActivitySummary from '~/components/molecule/ActivitySummary';
import { ANIMATION_CONFIG } from '~/styles/constants';

type Activity = {
  icon: IconType;
  value: number;
  description: string;
  label: string;
  link: string;
};

export type Props = {
  activities: { [key: string]: Activity };
  formatOptions?: Intl.NumberFormatOptions;

  style?: React.CSSProperties;
};

const ActivitySummaryList: React.FCC<Props> = ({
  activities,
  formatOptions,
  dataTestId = 'activity-summery-list',
  ...rest
}) => {
  const activityList = Object.keys(activities);

  const transitionProps: UseTransitionProps = {
    from: ANIMATION_CONFIG.from,
    enter: ANIMATION_CONFIG.to,
    leave: ANIMATION_CONFIG.from,
    config: {
      mass: 1,
      tension: 110,
      friction: 14,
    },
    trail: 125,
    keys: item => item,
  };
  const transitions = useTransition(activityList, transitionProps);

  return (
    <Container {...rest}>
      {transitions(
        (style, item, { key }, index) =>
          item && (
            <ActivitySummary
              key={key}
              animation={style}
              formatOptions={formatOptions}
              index={index}
              dataTestId={`${dataTestId}-${item}`}
              {...activities[item]}
            />
          ),
      )}
    </Container>
  );
};

const Container = styled.div<{}>(
  ({ theme }) => css`
    display: flex;
    flex-wrap: wrap;
    margin-bottom: ${theme.space('l')};

    ${theme.mq.lessThan('mobile')`
      flex-direction: column;
      margin-bottom: ${theme.space('l')};
    `}
  `,
);

export default ActivitySummaryList;
